module.exports = __webpack_public_path__ + "assets/img/0_01.5cd4d617.png";